<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn icon @click="back()">
							<v-icon>mdi-arrow-left</v-icon>
						</v-btn>
						{{ $t("title.create_coupon") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<WalletFormCoupon v-model="item"></WalletFormCoupon>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" @click.native="submit()" :loading="item.processing" :disabled="invalid">
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>
<script>
	import WalletFormCoupon from "@Wallet/forms/WalletFormCoupon.vue";
	export default {
		components: {
			WalletFormCoupon,
		},
		data() {
			return {
				item: this.$inertia.form({
					name: null,
					credit: null,
					price: null,
					description: null,
					image: {},
					is_private: false,
				}),
			};
		},
		methods: {
			submit() {
				this.item.post(this.$route("central.coupons.store"));
			},

			back() {
				window.history.back();
			}
		},
	};
</script>
